
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSSalesReportGrid extends Serenity.EntityGrid<POSSalesReportRow, any> {
        protected getColumnsKey() { return 'Retail.POSSalesReport'; }
        protected getDialogType() { return POSSalesReportDialog; }
        protected getIdProperty() { return POSSalesReportRow.idProperty; }
        protected getInsertPermission() { return POSSalesReportRow.insertPermission; }
        protected getLocalTextPrefix() { return POSSalesReportRow.localTextPrefix; }
        protected getService() { return POSSalesReportService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.setTitle("");
            this.addDateRangeFilter("TransDate", "Date");
        }
        protected createQuickSearchInput() { }
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();

            return [/*({
                title: 'Print Register',
                cssClass: 'export-pdf-button',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    Common.ReportHelper.execute({
                        reportKey: '',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date: this.view.params.Criteria
                        }
                    });
                }
            }
            )*/]
        }
        protected usePager(){ return false; }


    }
    @Serenity.Decorators.registerClass()
    export class POSSalesDayWiseGrid extends Serenity.EntityGrid<POSSalesReportRow, any> {
        protected getColumnsKey() { return 'Retail.POSSalesDayWise'; }
        protected getDialogType() { return POSSalesReportDialog; }
        protected getIdProperty() { return POSSalesReportRow.idProperty; }
        protected getInsertPermission() { return POSSalesReportRow.insertPermission; }
        protected getLocalTextPrefix() { return POSSalesReportRow.localTextPrefix; }
        protected getService() { return POSSalesDayWiseService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }
        protected createQuickSearchInput() { }
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();

            return [/*({
                title: 'Print Register',
                cssClass: 'export-pdf-button',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    Common.ReportHelper.execute({
                        reportKey: '',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date: this.view.params.Criteria
                        }
                    });
                }
            }
            )*/]
        }
        protected usePager() { return false; }


    }

}